import React from 'react'
import { observer } from 'mobx-react'

function ProductInput (props) {
  const input_ref = React.createRef()

  const update = function (new_quantity) {
    if (!isValidQuantity(new_quantity)) return
    setInputValue(new_quantity)
    let data = {
      product_id: props.product.product_id,
      quantity: new_quantity
    }
    props.onChange(data)
  }

  const getInputValue = function () {
    return input_ref.current.value
  }
  const setInputValue = function (val) {
    input_ref.current.value = val
  }

  const isValidQuantity = function (quantity) {
    return quantity >= 0
  }
  const onChange = function (e) {
    update(parseInt(e.target.value))
  }
  const increment = function () {
    update(parseInt(getInputValue()) + 1)
  }
  const decrement = function () {
    update(parseInt(getInputValue()) - 1)
  }

  return (
    <aside className={'product-input input-box'}>
      <div className="info-wrap">
        <figure dangerouslySetInnerHTML={{ __html: props.product.img }}></figure>
        <div className="info">
          <div className="info__name">{props.product.name}</div>
          <div className="info__description">{props.product.description}</div>
          <div className="info__price" dangerouslySetInnerHTML={{ __html: props.product.price }}/>
          {/* Should be formatted server side : ) */}
        </div>
      </div>
      <div className="form">
        <input type="number" defaultValue={props.quantity} onChange={(e) => onChange(e)} ref={input_ref}
               name={'qyantity[' + props.product_id + ']'}/>
        <button className={'increment icon-button'} onClick={() => increment()}>+</button>
        <button className={'decrement icon-button'} onClick={() => decrement()}>-</button>
      </div>
    </aside>
  )
}

export default observer(ProductInput)